module.exports = __webpack_public_path__ + "static/media/frozen4.bbfb4e40.png";